import type { SvgIconProps } from '@mui/material/SvgIcon';
import type * as React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';

import { android } from '@egr/xbox/utils/UserAgent';

export const BackIcon: React.FC<SvgIconProps> = (props) => {
    if (android) {
        return <ArrowBackIcon {...props}/>;
    }

    return <ArrowBackIos {...props} viewBox={props.viewBox ?? '0 0 12 24'}/>;
};